import { render, staticRenderFns } from "./TablesMenu.vue?vue&type=template&id=1f808d1f&"
import script from "./TablesMenu.vue?vue&type=script&lang=ts&"
export * from "./TablesMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports